import {
    Alert,
    AlertColor,
    Collapse,
    IconButton
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';

type BannerProps = {
    message: string;
    severity?: AlertColor;
    onClick?: () => void;
};

export default function BannerAlert({ message, severity = 'info', onClick = () => { } }: BannerProps) {
    const [open, setOpen] = useState(true);

    return (
        <Collapse in={open}>
            <Alert
                severity={severity}
                onClick={() => {
                    onClick();
                    setOpen(false);
                }}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={(event) => {
                            event.stopPropagation();
                            setOpen(false);
                        }}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                sx={{ borderRadius: 0, cursor: 'pointer' }}
            >
                {message}
            </Alert>
        </Collapse>
    );
}